import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTheme } from "@mui/material/styles"
import React from 'react'

const LiveStreamingDataTable = ({ SuperAdminLiveGetSetupFetchData }: { SuperAdminLiveGetSetupFetchData: any }) => {
    const tableData = SuperAdminLiveGetSetupFetchData?.data
    const theme = useTheme();
    const tableHeaderBg = theme.palette.mode === "dark" ? "#2D2D2D" : "#F0EFF8";
    return (
        <TableContainer component={Paper} sx={{ maxHeight: "50vh" }}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow sx={{ backgroundColor: tableHeaderBg }}>
                        <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                            Company Name
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                            User Name
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                            User Id
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                            Live Streaming Max Count
                        </TableCell>
                        <TableCell sx={{ fontWeight: 600, backgroundColor: tableHeaderBg }}>
                            Live Streaming Max Time
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {tableData?.map((row: any, index: number) => (
                        <TableRow key={index}>
                            <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                {row?.companyName}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                {row?.userName}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                {row?.fleetId}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                {row?.maxLiveStreamViewers}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 400, fontSize: "14px" }}>
                                {row?.maxViewDurationMillis} Seconds
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default LiveStreamingDataTable